module.exports = __webpack_public_path__ + "img/csr_swiper_04_03.2af138ab.jpg";